"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailService = exports.DEFAULT_OPTIONS = void 0;
/** The default options for the email service. */
exports.DEFAULT_OPTIONS = {};
/**
 * Sends emails on behalf of the system.
 */
class EmailService {
    constructor(options) {
        this.options = Object.assign(Object.assign({}, exports.DEFAULT_OPTIONS), options);
    }
}
exports.EmailService = EmailService;
//# sourceMappingURL=EmailService.js.map